import bustype from "./bustype.component";
import bustypeUrls from "./bustype.urls";
import BustypeTransforms from "./bustype.transforms";

const bustypeModule = angular
  .module("app.components.bustype", [])
  .component("bustypePage", bustype)
  .service("BustypeTransforms", BustypeTransforms)
  .config(bustypeUrls);

export default bustypeModule;



// WEBPACK FOOTER //
// ./src/pages/bustype/bustype.module.js